import React, { Component } from 'react';
import axios from 'axios'
import { connect } from 'react-redux';
import Server from './Server.js'
import Header from './Header.js'

import DatePicker from 'react-datepicker2';

import { Sidebar } from 'primereact/sidebar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import './raymand/Home.css'
const placesList = [
  {
    name:"THR",
    label:"تهران THR",
    desc:"فرودگاه بین‌المللی مهرآباد"
  },
  {
    name:"MHD",
    label:"مشهد MHD",
    desc:"فرودگاه بین‌المللی مشهد (فرودگاه شهید هاشمی‌نژاد)"
  },
  {
    name:"KIH",
    label:"کیش KIH",
    desc:"فرودگاه بین‌المللی کیش"
  },
  {
    name:"IFN",
    label:"اصفهان IFN",
    desc:"فرودگاه اصفهان (فرودگاه بین‌المللی شهید بهشتی)"
  },
  {
    name:"SYZ",
    label:"شیراز SYZ",
    desc:"فرودگاه بین‌المللی شیراز (فرودگاه شهید دستغیب)"
  },
  {
    name:"AZD",
    label:"یزد AZD",
    desc:"فرودگاه یزد (فرودگاه شهید صدوقی)"
  },
  {
    name:"KKS",
    label:"کاشان KKS",
    desc:"فرودگاه کاشان"
  },
  {
    name:"TBZ",
    label:"تبریز TBZ",
    desc:"فرودگاه بین‌المللی تبریز (فرودگاه شهید مدنی)"
  },
  {
    name:"BUZ",
    label:"بندر بوشهر BUZ",
    desc:"فرودگاه بوشهر"
  },
  {
    name:"GSM",
    label:"جزیره قشم GSM",
    desc:"فرودگاه دیرستان"
  },
  {
    name:"SRY",
    label:"ساری SRY",
    desc:"فرودگاه بین‌المللی دشت ناز ساری"
  }
]

class Ticket extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef()   // Create a ref object
    this.Server = new Server();
    localStorage.removeItem("food");
    this.state = {
      loginAccess: {},
      records: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      placesList:placesList

    }


  }
  componentDidMount() {
    if (!this.props.username) {
      this.setState({
        page: '/'
      })
    }
    this.login();
  }
  login() {
    let that = this;
    let param = {
    };
    let SCallBack = function (response) {
      const loginAccess = response.data.result;
      that.setState({
        loginAccess: loginAccess
      })
      if (!loginAccess.error)
        that.getAvailable15Days(loginAccess);
    };
    let ECallBack = function (error) {

    }
    this.Server.send("TravelApi/TicketLogin", param, SCallBack, ECallBack)
  }
  getAirPortList(loginAccess) {
    let that = this;
    let param = {
      accessToken: loginAccess.access_token,
      tokenType: loginAccess.token_type
    };
    let SCallBack = function (response) {
      const res = response.data.result;
    };
    let ECallBack = function (error) {

    }
    this.Server.send("TravelApi/getAirPortList", param, SCallBack, ECallBack)
  }
  getAvailable15Days(loginAccess) {
    let that = this;
    let param = {
      accessToken: loginAccess.access_token,
      tokenType: loginAccess.token_type
    };
    let SCallBack = function (response) {
      const res = response.data.result;
      if(!res.error){
        that.setState({
          records: res.data
        })
      }
    };
    let ECallBack = function (error) {

    }
    this.Server.send("TravelApi/getAvailable15Days", param, SCallBack, ECallBack)
  }
  searchAvailable(loginAccess) {
    let that = this;
    let param = {
      accessToken: this.state.loginAccess.access_token,
      tokenType: this.state.loginAccess.token_type,
      from: this.state.from,
      to: this.state.to,
      Date: this.state.Date.local("en").format("YYYY/M/D")
    };
    let SCallBack = function (response) {
      const res = response.data.result;
      if(!res.error){
        that.setState({
          records: res.data
        })
      }
      
    };
    let ECallBack = function (error) {

    }
    this.Server.send("TravelApi/getAvailable", param, SCallBack, ECallBack)
  }

  
  render() {

    return (

      <div style={{ height: '100%' }}>
        <Header ComponentName="خرید بلیط" ComponentLName="app-icon-15" />

        {!this.state.ShowLoading ?
          <div className="sarv-bg1 sarv-home-top-box" style={{ height: '100%', direction: 'rtl' }}>
            <div style={{ paddingTop: 20 }}>
              <DatePicker
                inputReadOnly={true}
                onChange={value => { this.setState({ Date: value }); }}
                value={this.state.untilDate}
                isGregorian={false}
                timePicker={false}
                className="p-inputtext p-component sarv-input full-width"
                placeholder="تاریخ حرکت"
                persianDigits={false}
              />
            </div>
            <div style={{ paddingTop: 5 }}>
              <InputText autocomplete="off" readOnly={true} value={this.state.fromLabel} autocomplete="off" keyboardType="default" placeholder="مبدا" name="fromLabel" onClick={()=>{
                this.setState({
                  searchVisible:true,
                  sidebarStatus:"from"
                })
              }} style={{ textAlign: "right", fontFamily: 'iranyekanwebmedium', width: '100%', border: 0 }} className="sarv-title2" />
            </div>
            <div style={{ paddingTop: 5 }}>
              <InputText autocomplete="off" readOnly={true} value={this.state.toLabel} autocomplete="off" keyboardType="default" placeholder="مقصد" name="toLabel" onClick={()=>{
                this.setState({
                  searchVisible:true,
                  sidebarStatus:"to"
                })
              }} style={{ textAlign: "right", fontFamily: 'iranyekanwebmedium', width: '100%', border: 0 }} className="sarv-title2" />
            </div>
            <div style={{ paddingTop:10,width:'100%',textAlign:'center' }}>
            <Button className="iranyekanwebmedium " style={{ width: '80%' }} onClick={() => {
                this.searchAvailable();
                    
                  }}><span className="iranyekanwebmedium medium-size" style={{ width: '100%',fontSize:20 }} >جستجو </span></Button>
            </div>


            <div >
            {this.state.records.map((item, index) => {
              return (
                <div key={index} style={{ marginBottom: 50 }}>
                  <div><span>نوع :</span><span>{item.displayLable}</span></div>
                  <div><span>خط هوایی :</span><span>{item.airline}</span></div>
                  <div><span>زمان پرواز :</span><span>{item.time_flight}   {item.date_flight}</span></div>
                  <div><span>قیمت :</span><span>{item.price_final.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</span></div>
                  <Button style={{ minWidth: 65 }} className="iranyekanwebmedium " onClick={() => {
                    this.setState({
                      selectedShop: item
                    })
                  }}><span className="iranyekanwebmedium medium-size" style={{ width: '100%' }} >خرید </span></Button>


                </div>
              )
            })}
            </div>  
            
            <Sidebar visible={this.state.searchVisible} style={{direction:'rtl'}} onHide={() => this.setState({
              searchVisible: false
            })}>
                <p>انتخاب {this.state.sidebarStatus == "from" ? "مبدا" : "مقصد"}</p>
                <InputText autocomplete="off" value={this.state.title} autocomplete="off" keyboardType="default" placeholder="جستجو" name="title" onChange={(text) => {
                var result = placesList.filter(function (obj) {
                  return obj.label?.indexOf(text.target.value) > -1;
                });
                this.setState({
                  title: text.target.value,
                  placesList: result

                })
              }} style={{ textAlign: "right", fontFamily: 'iranyekanwebmedium', width: '100%',border:"1px solid red",marginBottom:10 }} className="sarv-title2" />

              {this.state.placesList.map((item,index)=>{
                return(<div onClick={(event)=>{
                  const state = {
                    searchVisible : false,
                    title:item.label,
                    
                  }
                  
                  if(this.state.sidebarStatus == "from"){
                    state["fromLabel"] = item.label;
                    state["from"] = item.name

                  }
                  if(this.state.sidebarStatus == "to"){
                    state["toLabel"] = item.label;
                    state["to"] = item.name;
                  }
                  this.setState(state)
                }} style={{display:'flex',flexDirection:'column'}}>
                <span>
                {item.label}
                </span>
                <span style={{"color":"#c7c2c2"}}>
                {item.desc}
                </span>
                </div>)
              })}

            </Sidebar>
          </div>
          :
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
          </div>
        }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId
  }
}
export default connect(mapStateToProps)(Ticket)

